import { render, staticRenderFns } from "./CMSTemplateShow.vue?vue&type=template&id=1c5b88a4&"
import script from "./CMSTemplateShow.vue?vue&type=script&lang=js&"
export * from "./CMSTemplateShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports